<template>
  <div class="addPrevention">
    <div class="add-content-container">
      <div class="add-titieMain">
        <div class="add-title-container">防疫防治记录单</div>
        <div class="add-content">
          <div class="operation-btn">
            <el-button
              size="small"
              class="del"
              @click="onDelete"
              :disabled="enableTable || !edit"
            >删除</el-button>
            <el-button
              size="small"
              class="add"
              @click="onAdd"
              :disabled="enableTable || !edit"
            >增加</el-button>
            <el-button
              size="small"
              class="alter"
              @click="onAlter"
            >修改</el-button>
            <el-button
              size="small"
              class="save"
              v-throttle-button="onSave"
              :disabled="!enableTable || !edit"
            >保存</el-button>
            <el-button
              size="small"
              class="cancel"
              @click="onRollBack"
              :disabled="!enableTable || !edit"
            >撤销</el-button>
            <el-button
              size="small"
              class="close"
              @click="closeView"
            >关闭</el-button>
          </div>
          <!-- <div :class="{'content-form-container':true,'readonly':!edit}"> -->
          <div
            class="custom-search-container"
            style="margin-top: 15px"
          >
            <div class="custom-search-box">
              <div
                class="custom-search-box-warpper"
                v-if="show"
              >
                <span>流水号</span>
                <el-input
                  placeholder="请输入流水号"
                  v-model="order.numericalOrder"
                  size="small"
                  disabled
                >
                </el-input>
              </div>
              <div
                class="custom-search-box-warpper"
                v-if="addBaseList"
              >
                <span>基地</span>
                <el-select
                  v-model="order.fishBaseId"
                  filterable
                  placeholder="请选择"
                  size="small"
                  @change="baseChange"
                  :disabled="Boolean(orderId) || edit == false"
                >
                  <el-option
                    v-for="(item, index) in baseLists"
                    :key="index"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="custom-search-box-warpper"
                v-if="$store.state.companyList.isQlwVersion == true"
              >
                <span>仓库</span>
                <el-select
                  v-model="order.warehouseName"
                  :disabled="edit == false"
                  filterable
                  placeholder="请选择"
                  size="small"
                >
                  <el-option
                    v-for="(item, index) in storeHouseList"
                    :key="index"
                    :label="item.warehouseName"
                    :value="item.warehouseName"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="custom-search-box-warpper">
                <span>负责人</span>
                <el-select
                  v-model="order.leaderId"
                  filterable
                  placeholder="请选择"
                  size="small"
                  :disabled="edit == false"
                >
                  <el-option
                    v-for="item in companyUser"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="custom-search-box">
              <div class="custom-search-box-warpper">
                <span>塘口</span>
                <el-select
                  v-model="order.pond"
                  filterable
                  placeholder="请选择"
                  size="small"
                  @change="topPondChange"
                  :disabled="Boolean(orderId) || !edit"
                >
                  <el-option
                    v-for="(item, index) in topPondList"
                    :key="index"
                    :label="item.value"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
                <span v-if="order.pond != ''">&nbsp;&nbsp;&nbsp;周期：{{this.order.fishBatch}}</span>
              </div>
              <div
                class="custom-search-box-warpper"
                v-if="order.pond != ''"
                style="margin-left: -95px"
              >
                <span>日期</span>
                <el-date-picker
                  size="small"
                  v-model="order.dataDate"
                  type="date"
                  :disabled="edit == false"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerTimeOptions"
                >
                </el-date-picker>
              </div>
              <div
                class="custom-search-box-warpper"
                v-else
              >
                <span>日期</span>
                <el-date-picker
                  size="small"
                  v-model="order.dataDate"
                  type="date"
                  :disabled="edit == false"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerTimeOptions"
                >
                </el-date-picker>
              </div>
              <div class="custom-search-box-warpper">
                <span>单据号</span>
                <el-input
                  placeholder="请输入单据号"
                  v-model="order.billsNo"
                  size="small"
                  disabled
                >
                </el-input>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
      <div class="table-container">
        <table-ex
          :showIndex="true"
          :enable="enableTable && edit"
        >
          <thead-ex>
            <th-ex v-if="order.pond == ''">塘口</th-ex>
            <th-ex v-if="order.pond == ''">周期</th-ex>
            <th-ex>药品名称</th-ex>
            <th-ex>剂量单位</th-ex>
            <th-ex>药品来源</th-ex>
            <th-ex>成本均价</th-ex>
            <th-ex>用量</th-ex>
            <th-ex>用药方式</th-ex>
            <th-ex>用药时间</th-ex>
          </thead-ex>
          <tbody-ex>
            <tr-ex
              v-for="(item, index) in order.details"
              :key="index"
              @selected="selectedRow = item"
            >
              <td-ex
                v-if="order.pond == ''"
                v-model="item.pond"
                :editable="item.pondEdit"
                :list="fishPondList"
                display="value"
                take="key"
                type="cmb"
                @selected="pondChange(item)"
              ></td-ex>
              <td-ex v-if="order.pond == ''" v-model="item.fishBatch" :editable="item.pondEdit" type='text'></td-ex>
              <td-ex
                v-model="item.productId"
                type="cmb"
                :list="medicinesNameList"
                display="name"
                take="id"
                @selected="fishChange(item)"
              ></td-ex>
              <td-ex
                v-model="item.measureUnit"
                type="text"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              ></td-ex>
              <td-ex
                v-model="item.dealerId"
                type="cmb"
                :list="item.leaderList"
                display="dealerName"
                take="dealerId"
                @selected="leaderChange(item)"
              ></td-ex>
              <td-ex
                v-model="item.price"
                type="text"
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
              ></td-ex>
              <td-ex
                v-model="item.quantity"
                type="number"
                number
                onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
                positive
                :decimalLength="2"
              ></td-ex>
              <td-ex
                v-model="item.mode"
                type="cmb"
                :list="wayList"
                display="name"
                take="id"
              ></td-ex>
              <td-ex
                v-model="item.dataTime"
                type="cmb"
                :list="dataList"
                display="name"
                take="id"
              ></td-ex>
            </tr-ex>
          </tbody-ex>
          <tfoot-ex
            v-model="order.remark"
            @addRow="addRow"
            @delRow="delRow"
          >
            <td>合计</td>
            <td v-if="order.pond == ''">--</td>
            <td v-if="order.pond == ''">--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>{{ total("quantity") }}</td>
            <td>--</td>
            <td>--</td>
          </tfoot-ex>
        </table-ex>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";

export default {
  name: "addPrevention",
  data () {
    return {
      edit: !!this.$route.query.edit,
      // 限制日期
      pickerTimeOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      addBaseList: true,
      editBaseList: false,
      num: 3,
      show: false,
      orderId: this.$route.query.id,
      order: {
        fishBaseId: null,
        leaderId: null,
        warehouseId: null,
        warehouseName: "",
        pond: "",
        fishBatch: "",
        fishBatchId: "",
        dataDate: new Date(),
        numericalOrder: 0,
        billsNo: 0,
        remark: "",
        details: [],
      },
      dataList: [], //用药时间
      wayList: [], //用药方式
      baseLists: [], //基地列表
      companyUser: [], //负责人
      fishPondList: [], //塘口
      topPondList: [],
      medicinesNameList: [], //药品名称
      storeHouseList: [], //仓库
      enableTable: false,
      selectedRow: null,
      leaderList: [], // 饲料来源
      emptyRow: {
        pond: null,
        fishBatch: null,
        fishBatchId: null,
        productId: null,
        productName: "",
        measureUnit: "",
        quantity: 0,
        dataTime: null,
        mode: "",
        remark: "",
        price: "",
        dealerId: null, //来源
      },
    };
  },
  computed: {
    ...mapState(["loginUser"]),
  },
  async mounted () {
    // this.edit = await checkPermission.checkEdit(this.$route);
    this.baseLists = await this.getBaseList(); //基地
    let result = await Promise.all([
      this.getEmployees(), //获取负责人
      this.getStoreHouse(), //仓库
      this.setUseMedicineTime(), //用药时间
      this.getUseMedicineWay(), //用药方式
      // this.getFishMedicineList() //药品名称
    ]);
    // this.companyUser = result[0];
    this.storeHouseList = result[1];
    this.dataList = result[2];
    this.wayList = result[3];
    // this.order.leaderId = this.loginUser.id; //负责人默认当前用户
    if (this.$route.query.id) {
      document.title = this.edit ? "编辑防疫防治" : "查看防疫防治";
    } else {
      document.title = "增加防疫防治";
      if (this.storeHouseList.length > 0) {
        this.order.warehouseId = this.storeHouseList[0].warehouseID;
        this.order.warehouseName = this.storeHouseList[0].warehouseName;
      }
      // 添加基地默认项与 记住选中基地
      let addPreventionBase = storage.get("base");
      let oldBase = this.baseLists.find((f) => f.key == addPreventionBase);
      if (oldBase) {
        this.order.fishBaseId = oldBase.key;
      } else if (this.baseLists.length > 0) {
        this.order.fishBaseId = this.baseLists[0].key;
      }
      await this.baseChange(this.order.fishBaseId);
    }
    this.initData();
  },
  methods: {
    ...mapActions(modules.prevent, {
      addPrevent: "addPrevent", //添加
      updatePrevent: "updatePrevent", //修改
      getEditPrevent: "getEditPrevent", //编辑--获取行数据
      delPrevent: "delPrevent", //删除
    }),
    ...mapActions(modules.feeding, {
      getFeedLeaderData: "getFeedLeaderData", //来源
      getLayPrice: "getLayPrice", //获取成本均价
    }),
    ...mapActions(modules.dataDict, {
      setUseMedicineTime: "setUseMedicineTime", //用药时间
      getUseMedicineWay: "getUseMedicineWay", //用药方式
    }),
    ...mapActions(modules.base, {
      getBaseList: "getBaseList", //基地
    }),
    ...mapActions(modules.proofing, {
      getPondUnclearedBatchNo: "getPondUnclearedBatchNo", //周期批次
    }),
    ...mapActions(modules.cultureCycle, {
      addFishBatch: "addFishBatch",
    }),
    ...mapActions(modules.storeHouse, {
      getStoreHouse: "getStoreHouse", //仓库
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond", //塘口
    }),
    ...mapActions(modules.fish, {
      getFishMedicine: "getFishMedicine", //基地下药品名称
    }),
    ...mapActions({
      getSerialNumber: "getSerialNumber",
    }),
    ...mapActions(modules.user, ["getEmployees", "getEmployeesByFishBase"]), //获取负责人数据
    ...mapActions(["delVisitedViews"]),
    // 获取当前基地下的负责人员工列表
    async getEmployeesByFishBaseList () {
      const result = await this.getEmployeesByFishBase(this.order.fishBaseId);
      this.companyUser = result;
      this.companyUser.unshift({
        id: "",
        mobilePhone: "",
        phone: "",
        realName: "全部",
        name: "全部",
      });
      if (this.orderId) return;
      this.order.leaderId = result[0].id;
    },
    //总计
    total (prop) {
      let total = 0;
      this.order.details.forEach((item) => (total += Number(item[prop])));
      return total.toFixed(2);
    },
    //初始化表格
    initTable () {
      this.order.details = [];
      this.$nextTick(() => this.addRow());
    },
    //初始化数据
    async initData () {
      if (!this.orderId) {
        //新增
        this.order.numericalOrder = await this.getSerialNumber();
        this.topPondList = await this.getFishPond(this.order.fishBaseId);
        this.topPondList.unshift({
          key: "",
          value: "全部",
        });
        this.initTable();
      } else {
        //修改
        let result = await this.getEditPrevent(this.orderId);
        await this.baseChange(result.fishBaseId);
        this.order.warehouseName = result.warehouseName;
        this.order.fishBaseId = result.fishBaseId;
        this.fishPondList = await this.getFishPond(result.fishBaseId);
        // this.medicinesNameList = await this.getFishMedicine();
        this.getFishMedicine(result.fishBaseId).then((data) => {
          console.log(123, data);
          this.medicinesNameList = data;
        });
        let promises = result.details.map((item) =>
          (async () => {
            let result = await Promise.all([
              this.getLayPrice({
                productId: item.productId,
                fishBaseId: this.order.fishBaseId,
              }),
              this.getFeedLeaderData({
                fishBaseId: this.order.fishBaseId,
                productId: item.productId,
              }),
            ]);
            //item.price = result[0].toFixed(2);
            item.leaderList = result[1];
            item.dealerId = item.dealerId.toString();
            item.pondEdit = false;
            item.fishEdit = false;
            item.pond = item.fishPondId;
            item.productName = item.productName;
            item.fishBatch = item.fishBatchName;
          })()
        );
        await Promise.all(promises);
        // result.details.forEach(async item => {
        //   // let ass = [
        //   //   {
        //   //     id: item.productId,
        //   //     name: item.productName,
        //   //     unit: item.measureUnit
        //   //   }
        //   // ].concat(this.medicinesNameList);
        //   // this.medicinesNameList = ass;
        //   let result = await Promise.all([
        //     this.getLayPrice({
        //       productId: item.productId
        //     }),
        //     this.getFeedLeaderData({
        //       fishBaseId: this.order.fishBaseId,
        //       productId: item.productId
        //     })
        //   ]);
        //   item.price = result[0].toFixed(2);
        //   item.leaderList = result[1];
        //   item.dealerId = item.dealerId.toString();
        //   item.pondEdit = false;
        //   item.fishEdit = false;
        //   item.pond = item.fishPondId;
        //   item.productName = item.productName;
        //   item.fishBatch = item.fishBatchName;
        // });
        this.order = result;
        this.orderId = result.orderId;
        this.topPondList = await this.getFishPond(result.fishBaseId);
        this.topPondList.unshift({
          key: "",
          value: "全部",
        });
        if (result.fishPondId === null) {
          this.order.pond = "";
        } else {
          this.order.pond = result.fishPondId;
          this.order.fishBatch = result.details[0].fishBatchName;
          this.order.fishBatchId = result.details[0].fishBatchId;
        }
      }
      this.getEmployeesByFishBaseList();
      this.enableTable = true;
    },
    //改变基地数据
    async baseChange (e) {
      storage.set("base", e);
      this.getFishMedicine(e).then((data) => {
        console.log(123, data);
        this.medicinesNameList = data;
      });
      this.getFishPond(e)
        .then((data) => {
          this.fishPondList = data;
          if (this.fishPondList.length == 0) {
            this.$Alert.info({
              content: "当前选择的基地下面无塘口，请先添加",
              duration: 5000,
              status: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.enableTable = true;
      this.order.details.forEach((f) => {
        f.pond = null;
        f.fishBatchId = null;
        f.fishBatch = null;
      });
      if (!this.orderId) {
        this.topPondList = await this.getFishPond(e);
        this.order.pond = "";
        this.topPondList.unshift({
          key: "",
          value: "全部",
        });
      }
    },
    //药品名称
    async fishChange (e) {
      // console.log(e);

      let item = this.medicinesNameList.find((f) => f.id == e.productId);
      if (item) {
        e.productName = item.name;
        e.measureUnit = item.unit;
        e.scalingFactor = item.scalingFactor;
      }

      let obj = {
        fishBaseId: this.order.fishBaseId,
        productId: e.productId,
      };
      if (e.productId) {
        await this.getFeedLeaderData(obj)
          .then((data) => {
            if (data.length != 0) {
              e.leaderList = data;
              e.dealerId = e.leaderList[0].dealerId;
              e.dealerName = e.leaderList[0].dealerName;
            }
          })
          .catch((err) => {
            console.log(err);
          });
        let p = await this.getLayPrice({
          productId: e.productId,
          fishBaseId: this.order.fishBaseId,
        });
        e.price = p.toFixed(2);
      }
    },
    // 来源
    leaderChange (e) {
      let item = e.leaderList.find((f) => f.dealerId == e.dealerId);
      if (item) {
        e.dealerName = item.dealerName;
      }
    },
    async topPondChange (e) {
      console.log(e);
      if (e > 0) {
        let result = await this.getPondUnclearedBatchNo(e);
        console.log(result);
        if (result) {
          this.order.fishBatch = result.value;
          this.order.fishBatchId = result.key;
        } else {
          try {
            await MessageBox.confirm(
              "当前塘口尚未开启新的养殖周期，是否开启？",
              "提示"
            );
            try {
              await this.addFishBatch({
                fishPondId: e,
                batch: 0,
                startDate: this.order.date,
              });
              let newBatch = await this.getPondUnclearedBatchNo(e);
              this.order.fishBatchId = newBatch.key;
              this.order.fishBatch = newBatch.value;
            } catch (error) {
              this.order.pond = "";
              this.$Alert.info({
                content: "开启新周期失败",
                duration: 5000,
                status: "error",
              });
              // Message.error("开启新周期失败");
            }
          } catch (error) {
            this.order.pond = "";
          }
        }
      } else {
        this.order.fishBatch = "";
        this.order.fishBatchId = "";
      }
    },
    //改变塘口--联动周期
    async pondChange (row) {
      if (!row.pond) {
        //当什么都没有选中，则清理
        row.fishBatchId = null;
        row.fishBatch = null;
        return;
      }
      let result = await this.getPondUnclearedBatchNo(row.pond);
      if (result) {
        row.fishBatchId = result.key;
        row.fishBatch = result.value;
      } else {
        try {
          await MessageBox.confirm(
            "此塘口已清塘，是否开启新的养殖周期？",
            "提示"
          );
          try {
            await this.addFishBatch({
              fishPondId: row.pond,
              batch: 0,
              startDate: this.order.dataDate,
            });
            let newBatch = await this.getPondUnclearedBatchNo(row.pond);
            row.fishBatchId = newBatch.key;
            row.fishBatch = newBatch.value;
          } catch (error) {
            row.pond = null;
            this.$Alert.info({
              content: "开启新周期失败",
              duration: 5000,
              status: "error",
            });
            // Message.error("开启新周期失败");
          }
        } catch (error) {
          row.pond = null;
        }
      }
    },
    //保存
    async onSave () {
      if(this.order && this.order.relevancyId){
         Message.error(`该订单由采购订单自动生成，不能直接修改，请修改对应采购单`);
         return;
      }
      let err = null;
      if (this.$store.state.companyList.isQlwVersion == true) {
        this.order.warehouseId = this.storeHouseList.find(
          (f) => f.warehouseName == this.order.warehouseName
        ).warehouseID;
      }

      if (!this.order.fishBaseId) err = "基地必须选择";
      if (!this.order.dataDate) err = "日期必须选择";
      if (!this.order.leaderId) err = "负责人必须选择";
      // let list = this.order.details.filter(
      //   f => JSON.stringify(f) != JSON.stringify(this.emptyRow)
      // );
      let list = [];
      if (this.order.pond == "") {
        list = this.order.details.filter((f) => {
          return f.pond !== "" && f.pond !== null;
        });
      } else {
        list = this.order.details.filter((f) => {
          return f.productId !== "" && f.productId !== null;
        });
        list.map((item) => {
          item.pond = this.order.pond;
          item.fishBatch = this.order.fishBatch;
          item.fishBatchId = this.order.fishBatchId;
        });
      }
      let quantityReg = /^[0-9]{1,4}([.][0-9]{1,2})?$/; //用量
      if (list.length == 0) err = "不能提交空表单";
      list.forEach((item) => {
        if (!item.mode) {
          err = "用药方式必须选择";
        }
        if (!item.dataTime) {
          err = "用药时间必须选择";
        }
        if (item.quantity === 0) {
          err = "请输入用量";
        }
        if (!quantityReg.test(item.quantity)) {
          err = "用量范围为0~9999.00";
        }
        if (!item.pond) err = "塘口必须选择";
        if (!item.fishBatch || !item.fishBatchId) err = "批次必须选择";
        if (!item.productId) err = "药品名称必须选择";
      });

      if (err) {
        Message.error(err);
        return;
      }

      if (list.length > 0) this.order.details = list;
      this.$nextTick(async () => {
        try {
          if (this.orderId) {
            let result = await this.updatePrevent({
              id: this.orderId,
              data: this.order,
            });
            this.order.billsNo = result.billNo;
            this.orderId = result.orderId;
            this.$message({
              message: "保存成功",
              type: "success",
            });
          } else {
            let result = await this.addPrevent(this.order);
            this.orderId = result.orderId;
            this.order.billsNo = result.billNo;
            this.$message({
              message: "保存成功",
              type: "success",
            });
          }
          this.enableTable = false;
        } catch (error) {
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error",
          });
          // Message.error(error.response.data);
        }
      });
    },
    onAlter () {
      this.enableTable = true;
      this.edit = true;
      if (this.orderId) {
        this.order.details.forEach((item) => {
          item.pondEdit = false;
          item.fishEdit = false;
        });
      }
    },
    onAdd () {
      this.order.billsNo = 0;
      this.orderId = null;
      this.enableTable = true;
      this.$nextTick(() => this.initData());
    },
    async onDelete () {
      if (!this.orderId) {
        await this.$Alert.info({
          content: "未找到订单Id，无法删除",
          duration: 5000,
          status: "error",
        });
        // await Message.error("未找到订单Id，无法删除");
        return;
      }
      try {
        await MessageBox.confirm("是否删除此订单？", "提示");
        try {
          await this.delPrevent(this.orderId);
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.orderId = null;
          this.enableTable = true;
          this.$nextTick(() => this.initTable());
        } catch (error) {
          this.$Alert.info({
            content: error.response.data,
            duration: 5000,
            status: "error",
          });
          // this.$message.error(error.response.data);
        }
      } catch (err) {
        console.log("取消删除");
      }
    },
    onRollBack () {
      this.initData();
      this.edit = false;
      this.enableTable = false;
    },
    addRow () {
      let list = [];
      for (let i = 0; i < 5; i++) {
        list.push(JSON.parse(JSON.stringify(this.emptyRow)));
      }
      this.order.details = this.order.details.concat(list);
    },
    delRow () {
      this.order.details = this.order.details.filter(
        (f) => f != this.selectedRow
      );
    },
    closeView () {
      this.delVisitedViews([
        {
          meta: { affix: false },
          path: this.$route.path,
          title: this.$route.meta.title,
        },
      ]);
      this.$router.replace("/productionControl/preventionManagement");
    },
  },
};
</script>
<style>
.danger-color {
  color: #fff;
  border-color: #dd4b39;
  background-color: #dd4b39;
}
</style>
